var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDemo3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_24_202",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 3,
    width: 32,
    height: 34
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.46094 33.874C7.73894 33.874 7.12094 33.617 6.60694 33.103C6.09294 32.589 5.83594 31.985 5.83594 31.291V8.49903C5.83594 7.80436 6.07894 7.20037 6.56494 6.68703C7.0516 6.17303 7.5586 5.91603 8.08594 5.91603H16.1279C16.2946 5.11003 16.7043 4.43636 17.3569 3.89503C18.0096 3.35303 18.7666 3.08203 19.6279 3.08203C20.4893 3.08203 21.2463 3.35303 21.8989 3.89503C22.5516 4.43636 22.9753 5.11003 23.1699 5.91603H31.2109C31.9056 5.91603 32.5099 6.17303 33.0239 6.68703C33.5379 7.20037 33.7949 7.80436 33.7949 8.49903V17.832H31.7109V8.49903C31.7109 8.36036 31.6623 8.24236 31.5649 8.14503C31.4683 8.0477 31.3503 7.99903 31.2109 7.99903H27.0029V12.582H12.6279V7.99903H8.46094C8.29427 7.99903 8.16227 8.0477 8.06494 8.14503C7.96827 8.24236 7.91994 8.36036 7.91994 8.49903V31.291C7.91994 31.4297 7.96827 31.5477 8.06494 31.645C8.16227 31.7424 8.29427 31.791 8.46094 31.791H17.8359V33.874H8.46094ZM35.5449 36.999L30.9199 32.416C30.3919 32.8047 29.8086 33.0964 29.1699 33.291C28.5306 33.485 27.8639 33.582 27.1699 33.582C25.4199 33.582 23.9199 32.957 22.6699 31.707C21.4199 30.457 20.7949 28.9434 20.7949 27.166C20.7949 25.388 21.4199 23.881 22.6699 22.645C23.9199 21.409 25.4199 20.791 27.1699 20.791C28.9473 20.791 30.4609 21.416 31.7109 22.666C32.9609 23.916 33.5859 25.416 33.5859 27.166C33.5859 27.8327 33.4956 28.4994 33.3149 29.166C33.1349 29.8327 32.8366 30.416 32.4199 30.916L37.0029 35.541L35.5449 36.999ZM27.1699 31.499C28.3639 31.499 29.3846 31.0824 30.2319 30.249C31.0793 29.4157 31.5029 28.388 31.5029 27.166C31.5029 25.9714 31.0863 24.9574 30.2529 24.124C29.4196 23.2907 28.3919 22.874 27.1699 22.874C25.9753 22.874 24.9613 23.2907 24.1279 24.124C23.2946 24.9574 22.8779 25.9714 22.8779 27.166C22.8779 28.36 23.2946 29.3807 24.1279 30.228C24.9613 31.0754 25.9753 31.499 27.1699 31.499ZM20.0029 8.12403C20.4196 8.12403 20.7736 7.97836 21.0649 7.68703C21.3569 7.39503 21.5029 7.0407 21.5029 6.62403C21.5029 6.17936 21.3569 5.81836 21.0649 5.54103C20.7736 5.26303 20.4196 5.12403 20.0029 5.12403C19.5863 5.12403 19.2323 5.26303 18.9409 5.54103C18.6489 5.81836 18.5029 6.17936 18.5029 6.62403C18.5029 7.0407 18.6489 7.39503 18.9409 7.68703C19.2323 7.97836 19.5863 8.12403 20.0029 8.12403Z",
    fill: "#1C1B1F"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_24_202)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 17,
    height: 18,
    fill: "#A9CF3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 20L5 35H19L20 20H36V2H4V20Z",
    fill: "#587E85"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDemo3);
export default __webpack_public_path__ + "static/media/demo3.290c05051e5ae488fd6a5ff37e3b1e16.svg";
export { ForwardRef as ReactComponent };